import { combineReducers } from "redux";

import AppReducer from "./app/app-reducer";
import { pageReducer } from "./page/page.reducer";
import homeInsuranceReducer from "./home-insurance/home-insurance-reducer";

export default combineReducers({
    AppReducer,
    Page: pageReducer,
    HomeInsurance: homeInsuranceReducer,
});
